import { render, staticRenderFns } from "./DoubleNumberFrame.vue?vue&type=template&id=9210f7ac&scoped=true&"
import script from "./DoubleNumberFrame.vue?vue&type=script&lang=js&"
export * from "./DoubleNumberFrame.vue?vue&type=script&lang=js&"
import style0 from "./DoubleNumberFrame.vue?vue&type=style&index=0&id=9210f7ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9210f7ac",
  null
  
)

export default component.exports